import { SLIDE_IN_MENUS } from "./../screens/root/constants";
import { hookstate } from "@hookstate/core";
import { ContextReferrer, FunnelConfigTypes } from "../components/funnel/types";
import { ReaderNavigationContext } from "../screens/reader/types";
import { NAVBAR_HEIGHT } from "../screens/root/constants";

interface SlideInMenuConfig {
  menuInstanceId?: string;
  comicSlug?: string;
  releaseUuid?: string;
  artistSlug?: string;
  username?: string;
  userSubpage?: string;
  bundleUuid?: string;
  navigationContext?: ReaderNavigationContext;
}

interface SlideInMenuHistoryEntry {
  type: SLIDE_IN_MENUS;
  config?: SlideInMenuConfig;
}

export type rootComponentsStoreTypes = {
  funnelModal: FunnelConfigTypes;

  isSidebarOpen: boolean;

  isTopBarHidden?: boolean;
  topBarHeight: number;

  eventTrackingQueryParams?: string;
  eventContextReferrer?: ContextReferrer;

  openSlideInMenu?: SLIDE_IN_MENUS;
  slideInMenuConfig: SlideInMenuConfig;
  slideInMenuHistory: SlideInMenuHistoryEntry[];
  /**
   * Count of click-driven slide-in pushes since page load. Used to decide
   * whether to show a back arrow in SlideInHeader (shown only when > 0,
   * since navigate(-1) on a deep-linked island would exit the SPA).
   * Reset to 0 on hard reload, page navigate, and onCloseMenu.
   */
  modalDepth: number;

  mixpanelInitialized: boolean;
  isInitialLoad: boolean;

  timer: number;

  locationHistory: string[];
};
export const rootComponentsStore = hookstate<rootComponentsStoreTypes>({
  isInitialLoad: true,
  mixpanelInitialized: false,
  timer: Date.now(),

  isSidebarOpen: true,
  funnelModal: {},

  eventTrackingQueryParams: undefined,
  eventContextReferrer: undefined,

  isTopBarHidden: false,
  topBarHeight: NAVBAR_HEIGHT,

  openSlideInMenu: undefined,
  slideInMenuConfig: {},
  slideInMenuHistory: [],
  modalDepth: 0,
  locationHistory: [],
});
